// extend libraries
import { translateSingleString as remoteTranslateSingleString } from '@paywithextend/localization'
import { defaultLocale } from 'src/configurations'
import { getLocaleInfo } from 'src/localization/locales'
import { useTranslate } from 'src/localization/useTranslate'

/**
 * @deprecated Translates at call time with an explicitly passed locale and
 * WITHOUT white-label brand overrides. Prefer `useTranslate()` in components,
 * or `translateNode()` (src/localization/translateNode) outside component
 * renders — both read locale and brand from ConfigContext at render time.
 */
export const translateSingleString = (
  locale: string,
  source: string,
  expressions?: Record<string, string> | undefined,
): string => {
  return remoteTranslateSingleString(
    getLocaleInfo(locale).jsonTranslations,
    getLocaleInfo(defaultLocale).jsonTranslations,
  )(source, expressions)
}

export { useTranslate }

// The redux-connected <Trns /> component that used to be this module's
// default export is gone. Components call useTranslate(); non-render code
// (model getters, validators, redux action payloads, module-scope helpers)
// calls translateNode() from src/localization/translateNode. Do not
// reintroduce a default export here.
